import React, { useContext } from 'react'
import { Table } from 'components/common'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { TubularContext } from 'stores/TubularStore'
import { formatIppnFull } from 'utils/format'
import { UserContext } from "../../stores/UserStore"
import { FaArrowRight } from 'react-icons/fa'
import styled from 'styled-components'

const DetailArrow = styled(FaArrowRight)`
  color: #777;
  cursor: pointer;
  transition: 0.5s;
   
   &:hover{
    color: #aaa;
   }
`
const IppnCard = ({ data }) => {
    const history = useHistory()
    const { setIppnId, setValidId } = useContext(TubularContext)
    const { registryLogOld, registryLog } = useContext(UserContext)

    
    const getIppnData = (ippn, valid) => {
        registryLogOld('getIppnData', '/tlh/home')
        registryLog('home', 'click', 'get_ippn_data')

        ippn = ippn.replace(/[^0-9]/g, '')
        ippn ? setIppnId(ippn) : setIppnId('-')
        valid ? setValidId(valid) : setValidId('-') 

        history.push("/ippn/" + ippn + "/valid/" + valid )
    }

    const { t } = useTranslation()

    const columns = [
        {
            Header: t('tlh.home.tabs.ippn').toUpperCase(),
            accessor: (row) => formatIppnFull(row.ippn),
            id: 'ippn',
        },
        {
            Header: t('tlh.home.tabs.valId').toUpperCase(),
            accessor: (row) => row.valid,
            id: 'valid',
        },
        {
            Header: 'See piece',
            accessor: (row) => {
                return (
                    <DetailArrow size="1rem" onClick={() => getIppnData(row.ippn, row.valid)} />
                )
            },
        }
    ]

    return (
        <Table width="100%" columns={columns} data={data} sortable paginated style={{ whiteSpace: 'nowrap' }} ></Table>
    )
}

export default IppnCard
